import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { checkToken } from './interceptor.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private urlProd: string = environment.apiRoot;
  constructor(private http: HttpClient) {}

  private _refresrequired = new Subject<void>();

  get Refreshrequired() {
    return this._refresrequired;
  }

  listNotification(search: string, page: number, limit: number) {
    return this.http.get(
      `${this.urlProd}notifications/list-notifications?search=${search}&page=${page}&limit=${limit}`,
      { context: checkToken() }
    );
  }

  notificationDetail(idNotification: string) {
    return this.http.get(
      `${this.urlProd}notifications/detail-notification?id_notification=${idNotification}`,
      { context: checkToken() }
    );
  }

  addNotification(target: string, body: any) {
    return this.http
      .post(
        `${this.urlProd}notifications/add-notification?target=${target}`,
        body,
        { context: checkToken() }
      )
      .pipe(
        tap(() => {
          this.Refreshrequired.next();
        })
      );
  }

  editNotification(id: string, target: string, body: any) {
    return this.http
      .put(
        `${this.urlProd}/notifications/update-notification?id_notification=${id}&target=${target}`,
        body,
        { context: checkToken() }
      )
      .pipe(
        tap(() => {
          this.Refreshrequired.next();
        })
      );
  }

  deleteNotification(id: string) {
    return this.http
      .delete(
        `${this.urlProd}notifications/delete-notification?id_notification=${id}`,
        { context: checkToken() }
      )
      .pipe(
        tap(() => {
          this.Refreshrequired.next();
        })
      );
  }
}
